<template>
	<div id="companyyear"></div>
</template>

<script>
	import utils from "@/common/utils.js";
	let oldData = [];
	export default {
		props: {
			info: {
				type: Array,
				default () {
					return [];
				}
			},
			type: {
				type: Number,
				default: 0
			}
		},
		watch: {
			info: {
				handler(val) {
					//console.log(val);
					if (val && val.length) {
						oldData = val;
						this.options.xAxis.data = val.map(item => item.ReportDate);
						//this.options.dataZoom.end = this.type ? 100 : 50;
						this.options.title[1].text = `时间：${this.type?'季度':'年月'}`;
						this.options.legend.data = val[0].Items.map(item => item.LEVEL1);

						if (val[0].Items.length > 2) {
							this.options.series = [{
								name: val[0].Items[0].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[0].LEVEL1),
									//borderRadius: [0, 0, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[0].Money))
							}, {
								name: val[0].Items[1].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[1].LEVEL1),
									//borderRadius: [6, 6, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[1].Money))
							}, {
								name: val[0].Items[2].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[2].LEVEL1),
									//borderRadius: [6, 6, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[2].Money))
							}]
						} else if (val[0].Items.length > 1) {
							this.options.series = [{
								name: val[0].Items[0].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[0].LEVEL1),
									//borderRadius: [0, 0, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[0].Money))
							}, {
								name: val[0].Items[1].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[1].LEVEL1),
									//borderRadius: [6, 6, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[1].Money))
							}]
						} else {
							this.options.series = [{
								name: val[0].Items[0].LEVEL1,
								type: 'bar',
								stack: 'one',
								//barMaxWidth: 36,
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowColor: 'rgba(0,0,0,0.3)'
									}
								},
								itemStyle: {
									color: this.$utils.getInvColor(val[0].Items[0].LEVEL1),
									//borderRadius: [0, 0, 0, 0]
								},
								data: val.map(item => this.fixedVal(item.Items[0].Money))
							}]
						}
						//this.options.dataZoom[0].start = 12 / val.length > 1 ? 0 : (1 - (12 / val.length)) * 100;
						setTimeout(() => {
							this.myChart.clear();
							this.myChart.setOption(this.options);
							this.$forceUpdate();
						}, 200)
					} else {
						this.options.series = [];
						this.myChart.setOption(this.options);
						this.myChart.clear();
					}
				},
				deep: true,
				immediate: true
			}
		},
		data() {
			return {
				myChart: null,
				options: {
					tooltip: {
						trigger: 'axis',
						confine: true,
						hideDelay: 3000,
						formatter(params) {
							let itemStr = ``;
							params.forEach((item, index) => {
								let fx = oldData[item.dataIndex].Items.findIndex(it => it.LEVEL1 == item
									.seriesName);
								let it = oldData[item.dataIndex].Items[fx].MoneyRatio;
								itemStr = itemStr +
									`<div style="display:flex;align-items: center;" >${item.marker}
									<div style="font-size:14px;font-weight:400;margin:0px 20px 0px 8px;">${item.seriesName}  金额 / 同比</div>
									<div style="font-size:14px;font-weight:500;">
										${item.data} / ${it?it:'-'}%
									</div>
								</div>`
							})
							//${!index?'万':'个'}
							let viewStr = `<div><div>${params[0].name}</div>${itemStr}</div>`;
							return viewStr;
						}
					},
					title: [{
						text: '金额：万元',
						left: '4%',
						top: '2%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}, {
						text: '时间：年月',
						right: '4%',
						bottom: '18%',
						textStyle: {
							color: '#1D2129',
							fontSize: 12,
							fontWeight: 'normal'
						}
					}],
					dataZoom: [{
						type: 'slider',
						start: 65,
						end: 100,
						moveHandleSize: 10,
						fillerColor: 'transparent',
						brushSelect: false,
					}],
					toolbox: {
						show: true,
						top: 8,
						right: 140,
						feature: {
							saveAsImage: {
								icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA2ZJREFUWEfFl09oE0EUh783m4oHBRGFHnqImMTqSUFBUVAPgj0IHhS8iIoetKS1gqIHxYBeRMXWhFKxoAfBgwcLIgge9KAgWLAH0ZpY7EGxoIJgD7HZ3ZHdTbabv91ognNakpn3++bNe2/eCP95SJV+9PBiFi1dg82yptm09YWp4Y/NrCsHSCQvAudAFjdjJDDXRBubyA1OuL+t612CabxBk6fwaxPTd/OVducBEskUiAPwL2MWy9rge6H7eBS745NrUBVWMTkyXRvAJVXf3J1rHiP6NMqsol2QTKnvvBue9eeFBliT3IiW195CvZZsZnJBsTATQgPEkjtQ8qyRq8Lozc9JRSBl8l8A4snLiJzF5gyRwlhZDJgde1HcQOsT5DIjDrAXhK30QKJ/FPRR7zQZRBio+obrZNOn2wPgpd4TYGudY3tJxNpdCtbWe2A+/2tBlIm3xwOlbVd7whM3VRe2zPIx/bm9ACVPFIwRRJtE7CS/6cQw3gM/yaZXth+gMgiCwZ5Nu8ffnhioVzT+GsA5z4JxFmEzWp7TYQ6VldywVeqvAKK9nSwyHgKbAzrjzFl7mB6eqdZORUj8uAH6mPefGiS7/IJbGZsGiPV1oXgKdBeFnNTaXfz+jCU9TN18W1aC4z/uI+yrABtHFfZjRqJ+yV8wBhLJbnDvh07ARPQRPmTukeg/APoO4PQMs1iyn6mbTyAVISgu3MLWeUROFivhT5SMorVbAWkIYKsucN2+whVBHySbGfN3lTi5DewHPhwygNY7/J1rPUQu45XgRHIviANc3mHVBXAuCpGrwBJPXPWQHXpRddare2MYxqPA8XhTguKlRd0DUWzLAd7o26kLMK80A3pnw94gOrCMDmsMYbsfFxFrbe0McYLz+wiId1EtADCJZe0J12C6hkdBDhVdMMGc3VMzQ0JlATLBnFnbQKN8j/edR7jkewK9q8p7oQAsKx5u5zVoghmiuUwufaFsViiAOt1r2GKH118ewuZK6cbz19YFiPeuR4w3XhRbG8gNe319q0esbx8KJxsqgtB7DX0t5uorHPdpJwVbOESvQOQaEAVekU1vcawHHib9x0DfbqFkPVMmqJ2l2lLxNOs/gNaXEGJtAhkHdSpY2Kofp46yc/3atlOGWzfy+ZnGb8PWSTVl6Q8eGbAwgbTYagAAAABJRU5ErkJggg==',
								name: '公司商业销售汇总',
								show: true
							}
						}
					},
					grid: {
						left: '8%',
						right: '8%',
						bottom: '25%'
					},
					legend: {
						itemWidth: 35,
						itemHeight: 18,
						data: [],
						left: '10%',
						top: '1%'
					},
					xAxis: {
						data: [],
						axisTick: {
							show: false
						},
						axisLabel: {
							rotate: 30,
							fontSize: 12,
							color: '#1D2129'
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitLine: {
							show: false
						},
						splitArea: {
							show: false
						}
					},
					yAxis: {
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						axisLabel: {
							//rotate: 45,
							fontSize: 12,
							color: '#1D2129'
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#E5E6EB',
								type: [5, 10]
							}
						},
						splitArea: {
							show: false
						}
					},
					series: []
				}
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				let _this = this;
				this.myChart = this.$MyEcharts.init(document.getElementById('companyyear'));
				this.myChart.clear();
				this.myChart.setOption(this.options);
				window.addEventListener("resize", function() {
					_this.myChart.resize();
				});
			},
			fixedVal(val, num = 1) {
				return (val / 10000).toFixed(num);
			}
		}
	}
</script>

<style lang="less">
	#companyyear {
		height: 420px;
		padding: 16px;
	}
</style>